import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { TermType } from 'src/app/model/term-type';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class TermtypeDataService  extends DefaultDataService<TermType> {

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
    super('TermType', http, httpUrlGenerator);
}

override getAll(): Observable<TermType[]> {
    const url = this.urlProvider.getUrl(EndPoints.get_termTypes, undefined, undefined);
    return this.http
        .get(
            url,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        )
        .pipe(
            switchMap((res: any) => {
              return of( <TermType[]>JSON.parse(res.body['termTypes']));
                
            })
        );
}
}
